module.exports = __webpack_public_path__ + "img/allLabels.47368cc8.svg";